
import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { exemptionEndPoints } from '@src/constants/endpoints-constants';
const _httpService = new HttpService();
if (checkIsInternal()) {
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}
export const geoFilterResponseStateAndRegion = async (payload: any) => {
    try {
        const responseData: any = await _httpService.push(exemptionEndPoints.geoFilter, payload);
        return responseData;
    } catch (error) {
        return { status: false, error };;
    }
}

export const geoExemptionAndExclusion = async (payload: any) => {
    try {
        const responseData: any = await _httpService.push(exemptionEndPoints.geoExemption, payload);
        return responseData;
    } catch (error) {
        return { status: false, error };
    }
}

export const getTotalTinsData = async (payload: any) => {
    try {
        const responseData: any = await _httpService.push(exemptionEndPoints.totalTins, payload);
        return responseData;
    } catch (error) {
        return { status: false, error };
    }
}
